<div [id]="id">
  <input
    hint="search"
    placeholder="{{'search_by_name' | transloco}}"
    type="search"
    (ngModelChange)="onChangeText($event)"
    [(ngModel)]="defaultTextValue"
  />
</div>
